import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Games from '../components/games/Games'
import {
  resetGameState,
  playGame,
  changeGameState
} from '../store/actions/games'
import {
  GAME_ID,
  SCRATCH_CARD_VALUE,
  SCRATCH_GAME_STATUS
} from '../constants/game'
import {
  selectGameProfile,
  selectMainProfile,
  selectTokenProfile
} from '../store/selectors/common'
import {
  DEFAULT_CONTAINER_STATE,
  GAMES_PROCESS_STEP
} from '../constants/containerStates'
import ConfirmationPopup from '../components/games/ConfirmationPopup'
import { GAME_PROFILE_DISPATCH } from '../store/reducers/game/game'
import { changeMainState } from '../store/actions/main'
import { MAIN_PROFILE_DISPATCH } from '../store/reducers/main/main'
import { getRandomGif } from '../util/game.helpers'

const GamesContainer = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const gameProfile = useSelector(selectGameProfile)
  const tokenProfile = useSelector(selectTokenProfile)
  const mainProfile = useSelector(selectMainProfile)

  const [popupState, setPopupState] = useState({
    id: DEFAULT_CONTAINER_STATE.NONE,
    data: null
  })

  useEffect(() => {
    return () => {
      dispatch(resetGameState())
    }
  }, [])

  useEffect(() => {
    if (gameProfile.scratchStatus === SCRATCH_GAME_STATUS.REVEAL) {
      updateBalance(mainProfile.currentUserPoints - SCRATCH_CARD_VALUE)
    }
  }, [gameProfile.scratchStatus])

  const handleCompleteScratch = () => {
    setTimeout(() => {
      handleShowConfirmation()
    }, 3000)
  }

  const handleShowConfirmation = () => {
    setPopupState({
      id: GAMES_PROCESS_STEP.CONFIRMATION
    })
    updateBalance(mainProfile.currentUserPoints + gameProfile.result)
  }

  const updateBalance = (value) => {
    dispatch(
      changeMainState(
        MAIN_PROFILE_DISPATCH.PREVIOUS_USER_POINTS,
        mainProfile.currentUserPoints
      )
    )
    dispatch(changeMainState(MAIN_PROFILE_DISPATCH.CURRENT_USER_POINTS, value))
  }

  const handleNoPopup = () => {
    setPopupState({ data: null, id: DEFAULT_CONTAINER_STATE.NONE })
    dispatch(resetGameState())
  }

  const handleCancelPopup = () => {
    dispatch(
      changeGameState(
        GAME_PROFILE_DISPATCH.SCRATCH_STATUS,
        SCRATCH_GAME_STATUS.INIT
      )
    )
    handleNoPopup()
  }

  const handleScratchAgain = () => {
    handleNoPopup()
    handleOpenScratchCard()
  }

  const renderPopup = () => {
    switch (popupState.id) {
      case GAMES_PROCESS_STEP.CONFIRMATION:
        return (
          <ConfirmationPopup
            onSubmit={handleScratchAgain}
            onCancel={handleCancelPopup}
            t={t}
            value={gameProfile.result}
            symbol={tokenProfile.symbol}
            gif={getRandomGif()}
          />
        )

      default:
        break
    }
  }

  const handleOpenScratchCard = () => {
    dispatch(playGame(GAME_ID.RANDOM_VALUE, SCRATCH_CARD_VALUE))
  }

  return (
    <>
      <Games
        t={t}
        gameProfile={gameProfile}
        symbol={tokenProfile.symbol}
        onOpenScratchCard={handleOpenScratchCard}
        onCompleteScratch={handleCompleteScratch}
        currentUserPoints={mainProfile.currentUserPoints}
      />
      {renderPopup()}
    </>
  )
}

export default GamesContainer
